import http from '@/lib/admin/http'
import {Message, MessageBox} from 'element-ui'

export default {
  namespaced: true,
  state: {
    url: '/api/admin/userDetail',
    createUrl: '/api/admin/userDetail',
    list: [],
    newUserDetail: {},
    UserDetail: {},
    loading: false,
    page: {
      total: 0,
      pageSize: 8,
      currentPage: 1,
    },
    search: {
      page: 1
    },
    ruleForm: {},
    rules: {
      name: [
        {required: true, message: '姓名不能为空', trigger: 'blur', type: 'string'}
      ],
      sex: [
        {required: true, message: '性别不能为空', trigger: 'blur', type: 'string'}
      ],
      birthday: [
        {required: true, message: '生日不能为空', trigger: 'blur', type: 'string'}
      ],
      school_start: [
        {required: true, message: '入学时间不能为空', trigger: 'blur', type: 'string'}
      ],
      school_end: [
        {required: true, message: '结业时间不能为空', trigger: 'blur', type: 'string'}
      ],
      schoole_name: [
        {required: true, message: '学校名称不能为空', trigger: 'blur', type: 'string'}
      ],
      magor: [
        {required: true, message: '专业不能为空', trigger: 'blur', type: 'string'}
      ],
      magor_type: [
        {required: true, message: '专业类型不能为空', trigger: 'blur', type: 'string'}
      ],
      study_func: [
        {required: true, message: '学习方式不能为空', trigger: 'blur', type: 'string'}
      ],
      gradation: [
        {required: true, message: '层次不能为空', trigger: 'blur', type: 'string'}
      ],
      status: [
        {required: true, message: '毕业状态不能为空', trigger: 'blur', type: 'string'}
      ],
      dean_name: [
        {required: true, message: '院长姓名不能为空', trigger: 'blur', type: 'string'}
      ],
      card_id: [
        {required: true, message: '证书编号不能为空', trigger: 'blur', type: 'string'}
      ],
      card_number: [
        {required: true, message: '身份证号不能为空', trigger: 'blur', type: 'string'}
      ]
    }
  },
  mutations: {
    setSearch(state, search) {
      state.search = search;
    },
    setList(state, data) {
      state.list = data;
      state.loading = false;
    },
    setPage(state, page) {
      state.page = page;
      state.search.page = state.page.currentPage;
    },
    loading(state) {
      state.loading = true;
    },
    closeLoading(state) {
      state.loading = false;
    },
    resetCreate(state) {
      state.newUserDetail = {};
    },
    setCreate(state, userDetail) {
      state.newUserDetail = userDetail;
    },
    setUserDetail(state, UserDetail) {
      state.UserDetail = UserDetail;
    },
    setNewUserDetail(state, UserDetail) {
      state.newUserDetail = UserDetail;
    },
    resetUserDetail(state) {
      state.UserDetail = {}
    }
  },
  actions: {
    /**
     * 获取列表
     * @param  context
     * @param  page
     */
    getList(context, page) {
      //传入分页
      return new Promise((succes, faild) => {

        context.commit('loading');
        if (page) {
          context.commit('setPage', page);
        }
        //遮罩
        context.commit('loading');

        //获取数据
        http.getData(context.state.url, context.state.search).then(res => {
          //赋值
          context.commit('setList', res.data.list.data);

          let page = {
            'pageSize': res.data.list.per_page,
            'total': res.data.list.total,
            'currentPage': res.data.list.current_page,
          };

          //分页赋值
          context.commit('setPage', page);

          succes();
        }).catch(faild)
      });


    },

    create(context, userDetail) {
      if (!userDetail) {
        userDetail = context.state.newUserDetail;
      }
      return new Promise((success, faild) => {
        http.postData(context.state.createUrl, userDetail).then(res => {
          if (res.result.code == 1) {
            context.commit('resetCreate');
            success(res);
          } else {
            Message.error(res.result.message);
          }
        }).catch(faild)
      })

    },
    /**
     * 获取详情
     * @param  context
     * @param  userDetail
     * @returns  {Promise<any>}
     */
    show(context, userDetail) {


      return new Promise((success, faild) => {
        context.commit('loading');
        context.commit('resetUserDetail');

        http.getData(context.state.url + '/' + userDetail.id, userDetail)
          .then(res => {
            context.commit('closeLoading');
            console.log(context.state.loading);
            context.commit('setUserDetail', res.data.data);
            success(res.data)
          })
          .catch(res => {
            context.commit('closeLoading');
            faild()
          });
      })
    },

    /**
     * 更新
     * @param  context
     * @param  UserDetail
     * @returns  {Promise<any>}
     */
    update(context) {
      return new Promise((success, faild) => {
        http.putData(context.state.url + '/' + context.state.UserDetail.id, context.state.UserDetail)
          .then(res => {
            if (res.result.code == 1) {
              success(res.data)
            } else {
              Message.error(res.result.message);
            }
          }).catch(faild)
        ;
      })
    },
    destory(context, UserDetail) {
      MessageBox.confirm('确定要删除此数据？')
        .then(_ => {
          context.commit('loading');
          http.deleteData(context.state.url + '/' + UserDetail.id).then(res => {
            context.dispatch('getList');
          })
        })
        .catch(_ => {
          Message.error('未进行操作');
        });
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/vuex/modules/admin/user_detail.js